module.exports = __webpack_public_path__ + "static/img/empty.74bd5274.svg";